import { useCallback } from 'react';

import { usePanelPreferenceStore } from '@kc-console/context';

/**
 * GNB 패널 토글 상태 관리 훅
 *
 * usePanelPreferenceStore를 통해 패널 활성화 상태를 관리합니다.
 */
const usePanelToggleState = () => {
  // V2 Store (source of truth)
  const listPreference = usePanelPreferenceStore(state => state.preferences.list);
  const detailPreference = usePanelPreferenceStore(state => state.preferences.detail);
  const updatePreference = usePanelPreferenceStore(state => state.updatePreference);

  const updateListPanelEnableState = useCallback(
    (value: boolean) => {
      updatePreference('list', { enabled: value });
    },
    [updatePreference],
  );

  const updateDetailPanelEnableState = useCallback(
    (value: boolean) => {
      updatePreference('detail', { enabled: value });
    },
    [updatePreference],
  );

  return {
    enableListPanel: listPreference.enabled,
    enableDetailPanel: detailPreference.enabled,
    updateListPanelEnableState,
    updateDetailPanelEnableState,
  };
};

export default usePanelToggleState;
